import React from 'react';
import { SearchLocationWithOrganizationEntry } from '../OrganizationListing/OrganizationListingContainer';
import { FAVORITE_TYPE, useFavorites } from '@wwtr/libs/contexts';
import { SearchListingListItem } from '../SearchListingListItem';
import { Organizations_Organization_Entry } from '@wwtr/generated';

export type FacilitiesListingListProps = {
  entries: SearchLocationWithOrganizationEntry[];
  isLoading: boolean;
  onHover: (entryId: string) => void;
};

const loadingArray = new Array(20).fill(0);

export const FacilitiesListingList = ({
  entries,
  isLoading,
  onHover,
}: FacilitiesListingListProps) => {
  const { toggleFavorite, favorites } = useFavorites();

  const onClickFavorite = ($event, id: string) => {
    toggleFavorite(FAVORITE_TYPE.FACILITY_LOCATION, id);
  };

  return (
    <ul>
      {isLoading
        ? loadingArray.map((entry, index) => (
            <li key={`facility_result_loader_${index}`}>
              <SearchListingListItem isLoading={true} />
            </li>
          ))
        : entries?.map((entry, index) => (
            <li key={`facility_result_${index}`}>
              <SearchListingListItem
                isLoading={false}
                markerId={entry?.id}
                id={entry?.facility?.id}
                title={entry?.facility?.title}
                uri={entry?.facility?.uri}
                department={
                  (
                    entry?.facility
                      ?.organization[0] as Organizations_Organization_Entry
                  ).title
                }
                departmentTitle={`Aangeboden door ${
                  (
                    entry?.facility
                      ?.organization[0] as Organizations_Organization_Entry
                  ).title
                }`}
                address={`${entry?.visitAddress.parts.address} ${entry?.visitAddress.parts.number}, ${entry?.visitAddress.parts.city}`}
                mouseEnter={($event, entryId) => onHover(entryId)}
                mouseLeave={($event, entryId) => onHover(null)}
                onFavoriteClick={onClickFavorite}
                isFavorite={favorites[FAVORITE_TYPE.FACILITY_LOCATION].includes(
                  entry.id
                )}
              />
            </li>
          ))}
    </ul>
  );
};
